import { render, staticRenderFns } from "./wx-invite.vue?vue&type=template&id=43f6099e&scoped=true&"
import script from "./wx-invite.vue?vue&type=script&lang=js&"
export * from "./wx-invite.vue?vue&type=script&lang=js&"
import style0 from "./wx-invite.vue?vue&type=style&index=0&id=43f6099e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f6099e",
  null
  
)

export default component.exports